export default [
  { name: '擺脫無效社交', imgSrc: '', subTitle: '', section: 'section2' },
  { name: '配對流程', imgSrc: '', subTitle: '', section: 'section3' },
  { name: '安全保障', imgSrc: '', subTitle: '', section: 'section4' },
  { name: '你可能想問', imgSrc: '', subTitle: '', section: 'section5' },
  { name: '使用回饋', imgSrc: '', subTitle: '', section: 'section6' },
  // { name: '聯絡我們', imgSrc: '', subTitle: '', section: 'section7' },
]
